/*
 * Author: Dw
 * File Created: Wednesday, 24-08-07 04:08 pm
 * Last Modified: Thursday, 25-05-29 11:29 am, by Dw
 */

import type { LanguageType } from './hooks/useLanguage';

export const locales = ['en', 'zh'];

export const SGD_CURRENCY_UNIT = 'SGD';
export const USD_CURRENCY_UNIT = 'USD';

export const basePath = process.env.NEXT_PUBLIC_PREFIX_PATH || '';

export const externalLink: Record<
  'referralReward' | 'faq',
  Record<LanguageType, string>
> = {
  referralReward: {
    zh: 'https://help.thedecard.com/jiang-li-ji-hua/yao-qing-you-li',
    en: 'https://help.thedecard.com/en/reward/referral',
  },
  faq: {
    zh: 'https://help.thedecard.com/jiang-li-ji-hua/xiao-fei-fan-xian',
    en: 'https://help.thedecard.com/en/reward/cashback',
  },
};

export const DECARD_VISA_CATEGORY_ID = '30102000';
